"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortKeySources = sortKeySources;
exports.videoKeySources = videoKeySources;
const TYPE_PRIORITY = {
    person: 1,
    organization: 2,
    media: 3,
};
const priorityOf = (type) => TYPE_PRIORITY[(type ?? '').toLowerCase()] ?? 4;
/**
 * Key sources in display order: people, then organisations, then media, each
 * group by descending rating. Works for both the article (`PERSON`) and the
 * video (`Person`) entity enums. Returns a new array.
 */
function sortKeySources(entities, rating) {
    return [...(entities ?? [])].sort((a, b) => {
        const byType = priorityOf(a.type) - priorityOf(b.type);
        if (byType !== 0)
            return byType;
        return (rating(b) ?? 0) - (rating(a) ?? 0);
    });
}
/** A video's key sources: only `SOURCE` entities, in display order. */
function videoKeySources(entities) {
    return sortKeySources((entities ?? []).filter((e) => e.entityType === 'SOURCE'), (e) => e.credibilityRating);
}
